import React from 'react'

const Header = () => {
  return (
    <nav className="navbar p-3 bg-dark">
      <a href="/">🏠</a>
      <div className="h5 mb-0 text-center text-light font-weight-bolder">
        APPLICATION MANAGEMENT SYSTEM
      </div>
      <div/>
    </nav>
  )
}

export default Header
